export default __webpack_public_path__ + "static/media/preferedvendor_3.f6dbfa8f.png";